import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { I13nDiv } from 'react-i13n';
import BusinessIcon from '@mui/icons-material/Business';
import * as R from 'ramda';
import Link from '../../../common/components/core/Link';
import { getPartnerName } from '../../../main/components/PartnerManager/utils';
import type { AdPartner } from '../../../main/types/adPartnerTypes';
import { Label, Tooltip } from '@branchjs/neo-components';
export type Props = {
  index: number;
  partner: AdPartner;
  selectedPartner?: AdPartner | null;
  accessResources?: Array<string>;
  permission?: number;
  onClick: () => void;
  isCustom?: boolean;
  isOrgLevel?: boolean;
};
type State = {
  hover: boolean;
};
export class PartnerCard extends PureComponent<Props, State> {
  state: State = {
    hover: false,
  };

  onMouseEnter = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseLeave = () => {
    this.setState({
      hover: false,
    });
  };

  renderCustomPartnerLabel = (isCustom?: boolean, isOrgLevel?: boolean) =>
    isCustom &&
    (isOrgLevel ? (
      <Tooltip placement="top" title={this.renderOrgLevelTooltipContent()}>
        <span>
          <Label className="partner-card__custom_label" id="custom-partner-org-level-label" variant="warning">
            <BusinessIcon />
            <span>Custom</span>
          </Label>
        </span>
      </Tooltip>
    ) : (
      <Label className="partner-card__custom_label" id="custom-partner-label" variant="warning">
        Custom
      </Label>
    ));

  renderOrgLevelTooltipContent = () => (
    <span>
      This Custom Ad Partner was configured at the Organization-level.{' '}
      <Link
        href="https://help.branch.io/using-branch/docs/entity-views-access-controls-overview#organization-view"
        testid="org-level-tooltip"
      >
        Learn more
      </Link>
    </span>
  );

  render() {
    const { index, partner, selectedPartner, onClick, isCustom, isOrgLevel } = this.props;
    const { machine_name } = partner;
    const adPartnerName = getPartnerName(partner);
    const enabled = partner.enabled || R.path(['ingestion', 'enabled'], partner);
    const selected = selectedPartner && selectedPartner.machine_name === machine_name;
    const className = classNames('partner-card', {
      highlight: index % 2 === 0,
      enabled,
      selected,
    });
    const i13nParams = {
      partner: machine_name,
      currently_enabled: enabled,
    };
    const outerNode = document.getElementById(`outer-${machine_name}`);
    const innerNode = document.getElementById(`inner-${machine_name}`);
    const showScroll = outerNode && innerNode ? innerNode.offsetWidth > outerNode.offsetWidth : false;
    return (
      <I13nDiv
        onClick={onClick}
        className={className}
        data-testid={machine_name}
        bindClickEvent={true}
        i13nModel={{
          action: 'click',
          label: 'Partner in list',
          params: i13nParams,
        }}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <div id={`outer-${machine_name}`} className="partner-card__company_name">
          <span
            id={`inner-${machine_name}`}
            className={classNames({
              'inner-company-span': showScroll,
            })}
          >
            <span>{adPartnerName}</span>
          </span>
        </div>
        {this.renderCustomPartnerLabel(isCustom, isOrgLevel)}
      </I13nDiv>
    );
  }
}
export default PartnerCard;
